import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { headCommands } from '@shared/constants/CommandValues';
import { createUUID } from '@shared/constants/Keys';
import { CommonResourceKey } from '@shared/models/ResourceKeys';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function HeadControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    const fieldId = createUUID();
    return (
        <FormControl fullWidth>
            <InputLabel id={fieldId}>{t('common:head.label')}</InputLabel>
            <Select
                labelId={'head'}
                value={value}
                label={t('common:head.label')}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}>
                {headCommands.map((c) => (
                    <MenuItem key={c.value} value={c.value}>
                        {t(c.title as CommonResourceKey)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default HeadControlField;
